module.exports = __webpack_public_path__ + "static/media/elastic.c6963fde.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/elastic.png
// module id = 469
// module chunks = 0